import en from './en';

const common = {
  en,
};

export default common;
